import { render } from "./Fraction.vue?vue&type=template&id=3f21a1c2"
import script from "./Fraction.vue?vue&type=script&lang=js"
export * from "./Fraction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/Fraction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f21a1c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f21a1c2', __exports__)) {
    api.reload('3f21a1c2', __exports__)
  }
  
  module.hot.accept("./Fraction.vue?vue&type=template&id=3f21a1c2", () => {
    api.rerender('3f21a1c2', render)
  })

}


export default __exports__